export default {
	expectedRemoteCommandCallback: undefined,
	remoteCommandCallbackTimeout: undefined,

	updateScreen: (screenKey, otherParams = {}) => {
		// pp.log(`Projector into updateScreen, screenKey: '${screenKey}', otherParams:`, otherParams);
		// If this window is showing the projector
		if (!$(".ProjectorWrapper").length) {
			// pp.log("- nothing to do, no .ProjectorWrapper");
			return;
		}
		pp.projector.handleUpdateScreenInProjectorView(screenKey, otherParams);
	},

	handleUpdateScreenInProjectorView: (screenKey, otherParams) => {
		pp.log(
			"Projector updating view from `updateScreen`:",
			screenKey,
			otherParams,
		);
		const url = `/games/${pp.currentGameId}/projector.js${screenKey ? `?screen_key=${screenKey}` : ""}${pp.projector.paramsObjToUrlString(otherParams)}`;

		pp.projector.sendEvalMsgToFeed(
			"pp.projector.executingCommand",
			["pp.projector.updateScreen", [screenKey, JSON.stringify(otherParams)]],
			false,
		);
		$(".ProjectorWrapper").addClass("ProjectorWrapper--loading");

		$.get(
			url,
			(data) => {
				$(".ProjectorScreen").remove();
				$(".ProjectorWrapper").removeClass("ProjectorWrapper--loading");
				$(".ProjectorScreen").addClass("out slide-out-elliptic-bottom-bck");
				$(".ProjectorWrapper").append(
					$('<div class="ProjectorScreen in hidden"></div>"'),
				);
				$(".ProjectorScreen.in").html(data);
				$(".ProjectorScreen").attr("data-screen-key", screenKey);

				if (otherParams.quiz_id) {
					$(".ProjectorScreen").attr("data-item-id", otherParams.quiz_id);
				} else if (otherParams.group_id) {
					$(".ProjectorScreen").attr("data-item-id", otherParams.group_id);
					otherParams.callbackFunctionName = "pp.projector.showActorDraft";
					otherParams.callbackArgs = [otherParams.group_id];
				}

				setTimeout(() => {
					$(".ProjectorScreen.out").remove();
					$(".ProjectorScreen.in").removeClass("in hidden");
					$(document).trigger("page:change");
					if (!$(".QuestionResult__splash_content:visible").length) {
						return;
					}
				}, 300); // Allow for animations to complete
			},
			"html",
			// @ts-expect-error
		).success(() => {
			if (otherParams.callbackFunctionName) {
				const callbackFunction = eval(otherParams.callbackFunctionName);
				callbackFunction(
					otherParams.callbackArgs[0],
					otherParams.callbackArgs[1],
					otherParams.callbackArgs[2],
				);
			}
		});
	},

	handleUpdateScreenInProjectorRemote: (screenKey, otherParams) => {
		// Wait for the projector tab to do a callback
		// pp.log("updating screen item in remote:", screenKey, otherParams);
		pp.projector.setRemoteCommandCallbackTimeout("pp.projector.updateScreen", [
			screenKey,
			otherParams,
		]);
	},

	paramsObjToUrlString: (paramsObj) => {
		let str = "";
		for (let k in paramsObj) {
			if (!_.includes(["callbackFunctionName", "callbackArgs"], k)) {
				str += `&${k}=${paramsObj[k]}`;
			}
		}
		return str;
	},

	updateProjectorControlLinkStates: (screenKey, otherParams) => {
		$(".j-projector-change-screen-item").removeClass("active");
		if (otherParams && otherParams.quiz_id) {
			$(
				`.j-projector-change-screen-item[data-screen-key='${screenKey}'][data-item-id='${otherParams.quiz_id}']`,
			).addClass("active");
		} else {
			$(
				`.j-projector-change-screen-item[data-screen-key='${screenKey}']`,
			).addClass("active");
		}
	},

	initIndividualItemRemote: () => {
		// Mark the clicked button as active and unmark all other buttons for the Quiz takes remote
		// (The buttons for the projector remote are marked in `pp.projector.executingCommand`.)
		$(".ProjectorControl__remote__item .j-quiz-takers-remote a").on(
			"click",
			(event) => {
				$(".ProjectorControl__remote__item")
					.find(".j-quiz-takers-remote a")
					.removeClass("active");
				$(event.currentTarget).addClass("active");
			},
		);

		// Jump to the targeted Question slide and show/hide the splash screen
		$("a[data-projector-item-id]").on("click", (event) => {
			const $target = $(event.currentTarget);
			const $screenItemContainer = $target.closest(
				".j-projector-change-screen-item",
			);
			// @ts-expect-error
			const itemId = parseInt($target.attr("data-projector-item-id"), 10);
			switch ($screenItemContainer.data("screen-key")) {
				case "quiz_results":
					const hideSplashScreen =
						$target.attr("data-hide-splash-screen") == "true";
					// @ts-expect-error
					const quizId = parseInt($screenItemContainer.attr("data-item-id"));
					pp.projector.sendEvalMsgToFeed(
						"pp.projector.jumpToQuestionCarouselSlide",
						[itemId, quizId, hideSplashScreen],
					);
					break;

				case "groups_public_information":
					pp.projector.sendEvalMsgToFeed("pp.projector.jumpToGroupSlide", [
						itemId,
					]);
					break;

				default:
					console.error(
						`Unimplemented: Screen type ${$screenItemContainer.data("screen-key")}`,
					);
			}
		});
	},

	sendEvalMsgToFeed: (
		functionName,
		functionArguments,
		setRemoteCommandCallbackTimeout = true,
	) => {
		// pp.log("Projector sending eval:", functionName, functionArguments, setRemoteCommandCallbackTimeout);
		const stringifiedFunctionArguments = functionArguments
			.map((arrayItem) => {
				if (typeof arrayItem == "object") {
					return JSON.stringify(arrayItem);
				}
				if (typeof arrayItem == "string") {
					// Else
					return `"${arrayItem}"`;
				}
				return arrayItem; // Else
			})
			.join(", ");
		// @ts-expect-error
		PrivatePub.fayeClient
			.publish(
				`/feed/actor/${pp.currentActorId}`,
				{ eval: `${functionName}(${stringifiedFunctionArguments})` },
				{ attempts: 3 },
			)
			.then(
				function () {
					// pp.log("PROJECTOR message received by Faye server!");
					if (setRemoteCommandCallbackTimeout) {
						pp.projector.setRemoteCommandCallbackTimeout(
							functionName,
							functionArguments,
						);
					}
				},
				function (error) {
					pp.log(
						"PROJECTOR Faye error while sending message -- error:",
						error.message,
					);
				},
			);
	},

	// NB the `quizId` is only used in the call to `pp.projector.sendEvalMsgToFeed`
	showQuestionCarouselSlide: (questionId, quizId, hideSplashScreen) => {
		const $target = $(`.QuizResults [data-question-id='${questionId}']`);
		const targetIdx = $(`.QuizResults [data-question-id]`).index($target);
		if (targetIdx > -1) {
			pp.quiz.showQuestionResult($target.parents(".QuizResults"), targetIdx);
			$(`[data-question-id='${questionId}'] .QuestionResult__splash`)[
				hideSplashScreen ? "addClass" : "removeClass"
			]("hidden");
			if ($target.find(".QuestionResult:visible.QuestionResult--commentable")) {
				$(".QuizResultsContainer").css({
					maxHeight: "none",
				});
			}
		}
		pp.projector.sendEvalMsgToFeed(
			"pp.projector.executingCommand",
			[
				"pp.projector.jumpToQuestionCarouselSlide",
				[questionId, quizId, hideSplashScreen],
			],
			false,
		);
	},

	showGroupSlide: (groupId) => {
		const $target = $(
			`.ProjectorGroupsOverview__group[data-group-id='${groupId}']`,
		);
		if ($target.length) {
			$target.siblings().removeClass("animated fadeIn").addClass("hidden");
			$target.removeClass("hidden").addClass("animated fadeIn");
		}
		pp.projector.sendEvalMsgToFeed(
			"pp.projector.executingCommand",
			["pp.projector.jumpToGroupSlide", [groupId]],
			false,
		);
	},

	jumpToQuestionCarouselSlide: (questionId, quizId, hideSplashScreen) => {
		if (!$(".ProjectorScreen").length) {
			// We're not showing the projector in this tab
			return;
		}
		if (
			$(".ProjectorScreen").attr("data-screen-key") != "quiz_results" ||
			quizId != $(".ProjectorScreen").attr("data-item-id")
		) {
			pp.projector.updateScreen("quiz_results", {
				quiz_id: quizId,
				callbackFunctionName: "pp.projector.showQuestionCarouselSlide",
				callbackArgs: [questionId, quizId, hideSplashScreen],
			});
			return;
		}
		pp.projector.showQuestionCarouselSlide(
			questionId,
			quizId,
			hideSplashScreen,
		);
	},

	jumpToGroupSlide: (groupId) => {
		if (!$(".ProjectorScreen").length) {
			// We're not showing the projector in this tab
			return;
		}
		if (
			$(".ProjectorScreen").attr("data-screen-key") !=
			"groups_public_information"
		) {
			pp.projector.updateScreen("groups_public_information", {
				callbackFunctionName: "pp.projector.showGroupSlide",
				callbackArgs: [groupId],
			});
			return;
		}
		pp.projector.showGroupSlide(groupId);
	},

	showActorDraft: (groupId) => {
		const $tab = $(`[href="#info-block-${groupId}"]`);
		$tab.trigger("click");
	},

	executingCommand: (functionName, functionArguments) => {
		// pp.log(`Projector got executingCommand callback, functionName: '${functionName}, functionArguments:`, functionArguments);
		pp.projector.attemptRemoteCallbackTimeoutRedemption(
			functionName,
			functionArguments,
		);

		switch (functionName) {
			case "pp.projector.jumpToQuestionCarouselSlide":
				// NB expect the first item in `functionArguments to be the Question id and the third to be the `hideSplashScreen` flag
				const $questionButtonTarget = $(
					`a[data-projector-item-id='${functionArguments[0]}'][data-hide-splash-screen='${functionArguments[2]}']`,
				);

				// Mark the button active
				$(".ProjectorControl__remote__item")
					.find(".j-projector-remote a")
					.removeClass("active");
				$questionButtonTarget.addClass("active");
				break;

			case "pp.projector.jumpToGroupSlide":
				const $groupButtonTarget = $(
					`a[data-projector-item-id='${functionArguments[0]}']`,
				);
				$(".ProjectorControl__remote__item").removeClass("active");
				$groupButtonTarget.addClass("active");
				break;

			case "pp.projector.updateScreen":
				const screenKey = functionArguments[0];
				const otherParams = functionArguments[1];
				pp.projector.updateProjectorControlLinkStates(screenKey, otherParams);
				break;

			default:
				console.error(`Not implemented: ${functionName}`);
		}
	},

	handleQuestionResultSplashClick: (event) => {
		const $currentTarget = $(event.currentTarget);
		const questionId = $currentTarget
			.closest(".QuestionResult")
			.attr("data-question-id");
		const quizId = $currentTarget.closest(".QuizResults").attr("data-quiz-id");
		pp.projector.showQuestionCarouselSlide(questionId, quizId, true);
	},

	setRemoteCommandCallbackTimeout: (functionName, functionArguments) => {
		// pp.log(`into setRemoteCommandCallbackTimeout, functionName: '${functionName}', functionArguments:`, functionArguments);
		// @ts-expect-error
		pp.projector.expectedRemoteCommandCallback = {
			functionName: functionName,
			functionArguments: functionArguments.map((arrayItem) => {
				return typeof arrayItem == "object"
					? JSON.stringify(arrayItem)
					: arrayItem;
			}),
		};

		// Give the projector view time to open the page and ping back (via `executingCommand` and `attemptRemoteCallbackTimeoutRedemption`)
		$(".ProjectorControl__launch-projector").addClass(
			"ProjectorControl__launch-projector--in-timeout",
		);
		// @ts-expect-error
		pp.projector.remoteCommandCallbackTimeout = setTimeout(() => {
			const $openProjectorTabLink = $(".j-projector-tab-link");
			// pp.log("Projector in opening timeout, link:", $openProjectorTabLink);
			if ($openProjectorTabLink.length) {
				// Trigger opening the proejctor tab
				// @ts-expect-error
				$.rails.handleMethod($openProjectorTabLink);
				$(".ProjectorControl__launch-projector").removeClass(
					"ProjectorControl__launch-projector--in-timeout",
				);
				// Give the new projector tab enough time to fully load
				setTimeout(() => {
					// pp.log("Projector: in timeout #1 to resend eval msg to projector:", functionName, functionArguments)
					pp.projector.sendEvalMsgToFeed(
						functionName,
						functionArguments,
						false,
					);
				}, 2500);
				setTimeout(() => {
					// pp.log("Projector: in timeout #2 to resend eval msg to projector:", functionName, functionArguments)
					pp.projector.sendEvalMsgToFeed(
						functionName,
						functionArguments,
						false,
					);
				}, 5000);
			} else {
				pp.notifications.display(
					"notice",
					I18n.t("projector.no_projector_tab_responded"),
					{ dismissable: true },
				);
			}
		}, 2000);
	},

	attemptRemoteCallbackTimeoutRedemption: (functionName, functionArguments) => {
		if (!pp.projector.expectedRemoteCommandCallback) {
			// pp.log("Projector not expeting timeout redemption");
			return;
		}
		const expectedFunctionName =
			// @ts-expect-error
			pp.projector.expectedRemoteCommandCallback.functionName;
		const expectedFunctionArguments =
			// @ts-expect-error
			pp.projector.expectedRemoteCommandCallback.functionArguments;
		pp.log(
			"attemptRemoteCallbackTimeoutRedemption, incoming:",
			functionName,
			functionArguments,
			"expected:",
			expectedFunctionName,
			expectedFunctionArguments,
		);
		// NB use `JSON.stringify` to compare arrays, just doing `array1 == array2` does not work
		if (
			expectedFunctionName != functionName ||
			JSON.stringify(expectedFunctionArguments) !=
				JSON.stringify(functionArguments)
		) {
			pp.log("- mismatch");
			return; // Not the callback we are looking for
		}
		pp.log("clearing remoteCommandCallbackTimeout");
		pp.projector.expectedRemoteCommandCallback = undefined;
		clearTimeout(pp.projector.remoteCommandCallbackTimeout);
		$(".ProjectorControl__launch-projector").removeClass(
			"ProjectorControl__launch-projector--in-timeout",
		);
	},
};
